import {ProductImageCarousel} from "./modules/ProductCarousels";


ProductImageCarousel();


const originalPriceRange = $('.price-wrapper .price').html();
const variationForm = $('form.variations_form');
const technicalData = $('.technical-data__content');
const originalTechnicalData = technicalData.html();

variationForm.on('found_variation', function (event, variation) {
    if (variation.price_html) {
        $('.price-wrapper .price').html(variation.price_html);
    }

    if (variation.technical_data) {
        technicalData.html(variation.technical_data);
    }

});

variationForm.on('reset_data', function () {
    $('.price-wrapper .price').html(originalPriceRange);
    technicalData.html(originalTechnicalData);
});